import { Specification } from '@a3l/core';

export class HasValidPasswordSpecification extends Specification<any> {
  isSatisfiedBy(candidate: any): boolean {
    const { has_valid_password: condition } = candidate || {};

    return condition;
  }
}
